import type { FC } from 'react';
import React from 'react';
import classNames from 'clsx';

import type { AvatarWrapperProps } from '../../../LoginSocialBar.types';
import { AvatarIcon, AvatarState, Layout } from '../../../LoginSocialBar.types';
import { Avatar } from './Avatar';

import styles from './Avatar.scss';

// TODO - Reuse Icon Component
export const AvatarWrapper: FC<AvatarWrapperProps> = ({
  id,
  isLoggedIn,
  avatarUri,
  iconSize,
  userName,
  avatarIcon,
  customAvatar,
  displayMode,
}) => {
  const isMemberInitials =
    isLoggedIn &&
    (displayMode === Layout.MemberInitials ||
      avatarIcon === AvatarIcon.Initials);

  const shouldShowCustomAvatar =
    avatarIcon === AvatarIcon.Custom && !!customAvatar;

  const imageOrVector =
    avatarUri || shouldShowCustomAvatar
      ? AvatarState.Image
      : AvatarState.Vector;

  const avatarState =
    isMemberInitials && isLoggedIn ? AvatarState.Initials : imageOrVector;

  const isPlaceholder = avatarState === AvatarState.Vector;

  return (
    <div
      className={classNames(styles.avatar, {
        [styles.withBorder]: !isPlaceholder,
        [styles.withLoggedOutHeight]: !isLoggedIn,
      })}
    >
      <Avatar
        id={id}
        size={iconSize}
        name={userName}
        url={shouldShowCustomAvatar ? customAvatar : avatarUri}
        state={avatarState}
        className={classNames({
          [styles.memberInitials]: isMemberInitials,
          [styles.avatarPlaceholder]: isPlaceholder,
        })}
      />
    </div>
  );
};
